<template>
<Layout :footer-style="2">
  <div class="ServiceSupport">
    <div class="ServiceSupport_content ">
      <StaticBanner :banner-date="bannerDate"></StaticBanner>
      <div class="titles">
        <div class="in_titles">
          <div class="in_titles_left">
            <img class="in_titles_left_img" src="../assets/images/industry/tb.png" alt="">
            <div><span style="margin-right: 10px;">&gt;</span><span style="font-size: 18px;">服务与支持</span></div>
          </div>
          <div class="in_titles_right">
          </div>
        </div>
      </div>
      <div class="content_body container">
        <div class="group_mid">
          <div class="mid_top">
            <div class="mid_top_title w-700 rn-section-gap fs-1">完整的一体化交付模式</div>
            <SetupScroll></SetupScroll>
          </div>
          <div class="mid_bot">
            <img src="@/assets/images/serviceSupport/TOP-copy.png" alt="" />
          </div>
        </div>
      </div>
      <div class="radio_slide d-none d-lg-block">
        <img src="../assets/images/serviceSupport/08-01.png" alt="" class="radio_slide_bg" />
        <div class="radio-anm">
          <img src="../assets/images/serviceSupport/radio/white-0.png" alt="" class="radio_slide_white white-0" />
          <img src="../assets/images/serviceSupport/radio/white-1.png" alt="" class="radio_slide_white white-1"/>
          <img src="../assets/images/serviceSupport/radio/white-2.png" alt="" class="radio_slide_white white-2"/>
        </div>
        <div class="text-title">
          <div class="bg-anm2 bg-top" data-aos="zoom-in"> 
            <div class="bg-anm1">
              <div class="title-bg w-700">
                博信诚
              </div>
            </div>
          </div>
          <div class="bg-anm2 bg-bottom" data-aos="zoom-in">
            <div class="bg-anm1">
              <div class="title-bg2 color-white w-700">
                客户
              </div>
            </div>
          </div>
          <div class="text-liness">
            <div class="text-line line1" data-aos="fade-right">
              <div class="text-cent color-white">组织人力<br/>方案设计</div>
              <img src="../assets/images/serviceSupport/radio/white-line-L.png" alt="">
            </div>
            <div class="text-line line2" data-aos="fade-right">
              <div class="text-cent color-white">业务流程<br/>方案设计</div>
              <img src="../assets/images/serviceSupport/radio/white-line-L.png" alt="">
            </div>
            <div class="text-line line3" data-aos="fade-right">
              <div class="text-cent color-white">数据标准<br/>方案设计</div>
              <img src="../assets/images/serviceSupport/radio/white-line-L.png" alt="">
            </div>
            <div class="text-line line4" data-aos="fade-right">
              <div class="text-cent color-white">输出结果<br/>规范设计</div>
              <img src="../assets/images/serviceSupport/radio/white-line-L.png" alt="">
            </div>
            <div class="text-line line5" data-aos="fade-left">
              <img src="../assets/images/serviceSupport/radio/white-line-R.png" alt="">
              <div class="text-cent color-white">审核、操作<br/>细则编写</div>
            </div>
          </div>
          <div class="text-center color-white fs-1 w-700 zero-title" data-aos="fade-up">
            丰富的咨询+系统<br/>落地复合实施项目交付落地
          </div>
        </div>
      </div>
      <div class="d-block d-lg-none">
        <img src="../assets/images/serviceSupport/radio/radio-phone.png" alt="">
      </div>
      <div class="success container">
        <div class="rn-section-gap">
          <div class="fs-1 w-700 text-center">基于博信诚云智慧业财一体化</div>
          <div class="fs-1 w-700 text-center">解决方案的企业和公共组织</div>
        </div>
        <div style="position:relative">
          <!-- <seamlescroll  class="" :type="4"></seamlescroll> -->
          <seamlescroll class="d-none d-lg-block" :type="9" ></seamlescroll>
          <seamlescroll class="d-block d-lg-none" :type="3"></seamlescroll>
        </div>
      </div>
      <div class="content_bottom container">
        <div class="content_bottom_title w-700 rn-section-gap fs-1">博信诚为您提供咨询、产品、实施、定制开发等综合性服务</div>
        <div class="content_bottom_list" v-if="windowWidth>767">
          <div class="col-lg-3 col-12" v-for="(item,index) in bottonList" :key="index">
            <div class="moreBox">
              <div class="moreBoxImgs">
                <img class="moreBoxImg1" :src="item.img" alt="">
                <!-- <img class="moreBoxImg2" src="@/assets/images/serviceSupport/blue-shade.png" alt=""> -->
                <img class="moreBoxImg2" src="@/assets/images/industry/bankground.png" alt="">
              </div>
              <div class="moreBoxContent">
                  <img :src="item.imgIcon" alt="" />
                  <h4 class="aaa color-white">{{item.title}}</h4>
                </div>
              <div class="list-font color-white">
                {{item.content}}
              </div>
            </div>
          </div>
        </div>
        <div class="content_bottom_list" v-else>
          <swiper
            class="mySwipes"
            :options="swiperOption"
          >
          <swiper-slide v-for="(item,index) in bottonList" :key="index">
            <div class="moreBox">
              <div class="moreBoxImgs">
                <img class="moreBoxImg1" :src="item.img" alt="">
                <!-- <img class="moreBoxImg2" src="@/assets/images/industry/bankground.png" alt=""> -->
              </div>
              <div class="moreBoxContent">
                  <img :src="item.imgIcon" alt="" />
                  <h4 class="aaa color-white">{{item.title}}</h4>
                </div>
              <!-- <div class="list-font color-white">
                {{item.content}}
              </div> -->
            </div>
          </swiper-slide>
        </swiper>
        </div>

      </div>
    </div>
  </div>
</Layout>
</template>
<style lang="scss">
.ServiceSupport {
  
}
.ServiceSupport_content {
  margin: 0 auto;
  max-width: 1920px;
  margin-top: 80px;
  .titles {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #F6F7FA;
    .in_titles {
      display: flex;
      max-width: 1440px;
      height: 70px;
      width: 100%;
      align-items: center;

      .in_titles_left {
        display: flex;
        width: 50%;
        align-items: center;
        margin-left: 5%;
        .in_titles_left_img {
          height: 30%;
          margin-right: 10px;
        }
      }
      .in_titles_right {
        display: flex;
        flex: 1;
        justify-content: space-around;
        div{
          padding: 20px 0;
          cursor: pointer;
        }
        .changes{
          color: #186BB3;
          border-bottom: 4px solid #186BB3;
        }
      }
    }
  }
  .content_body {
    /*max-width: 1440px;
    margin: 0 auto;*/
    margin-bottom: 5rem;
    .group_mid {
      .mid_top {
        .mid_top_title {
          text-align: center;
          margin: 0;
        }
      }
    }
  }
  .radio_slide {
    position: relative;
    
    .radio_slide_bg {
      position: relative;
    }
    .text-title{
      .bg-top{
        position: absolute;
        top: 21%;
        left:35%;
      }
      .bg-bottom{
        position: absolute;
        top: 59%;
        left:57%;
      }
      .bg-anm2{
        background: url("../assets/images/serviceSupport/radio/radio-bg2.png") center no-repeat;
        width: 139px;
        height: 139px;
        cursor: pointer;
        .bg-anm1{
          background: url("../assets/images/serviceSupport/radio/radio-bg1.png") center no-repeat;
          width: 119px;
          height: 119px;
          margin: 10px 0 0 10px;
          padding: 10px 0 0 10px;
          .title-bg{
            background: url("../assets/images/serviceSupport/radio/radio-title.png") center no-repeat;
            width: 99px;
            height: 99px;
            text-align: center;
            line-height: 99px;
            color: #0a161e;
          }
          /*.title-bg2{
            background: url("../assets/images/serviceSupport/radio/radio-blue.png") center no-repeat;
            width: 99px;
            height: 99px;
            text-align: center;
            line-height: 99px;
            color: #0a161e;
          }*/
          .title-bg2{
            width: 99px;
            height: 99px;
            text-align: center;
            line-height: 99px;
            color: #0a161e;
            background: #00008b;
            border-radius: 50%;
          }
        }
        .radio-bg1{

        }
      }
      .text-liness{
        .text-line{
          display: flex;
          position: absolute;
          .text-cent{
            margin: 0 2rem;
            cursor: pointer;
          }
        }
        .line1{
          top: 22%;
          left: 15%;
        }
        .line2{
          top: 40%;
          left: 12%;
        }
        .line3{
          top: 58%;
          left: 12%;
        }
        .line4{
          top: 76%;
          left: 15%;
        }
        .line5{
          bottom: 45%;
          right: 15%;
        }
      }
      .zero-title{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
      }
    }
    .radio-anm{
      .radio_slide_white {
        display: block;
        position: absolute;
        top: 7%;
        left: 30%;
        width: 40%;
        
      }
      .white-0{
        animation:changeright0 30s linear infinite;
      }
      .white-1{
        animation:changeright1 25s linear infinite;
      }
      .white-2{
        animation:changeright2 25s linear infinite;
      }
    }
    @keyframes changeright1{
      0%{-webkit-transform:rotate(0deg) scale(0.8);}
      50%{-webkit-transform:rotate(180deg) scale(0.8);}
      100%{-webkit-transform:rotate(360deg) scale(0.8);}
    }
    @keyframes changeright2{
      0%{-webkit-transform:rotate(360deg) scale(0.8);}
      50%{-webkit-transform:rotate(180deg) scale(0.8);}
      100%{-webkit-transform:rotate(0deg) scale(0.8);}
    }
    @keyframes changeright0{
      0%{-webkit-transform:rotate(360deg) scale(0.8);}
      50%{-webkit-transform:rotate(180deg) scale(0.8);}
      100%{-webkit-transform:rotate(0deg) scale(0.8);}
    }
  }
  .success{
    background: #f6f7fa;
    margin-top: 5rem;
  }
  .content_bottom {
    margin-bottom: 5rem;
    .content_bottom_title {
      text-align: center;
      margin: 0;
    }
    .content_bottom_list {
      text-align: center;
      position: relative;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .moreBox {
        position: relative;
        transition: all 1s ease;
        margin: 0 10px;
        &:hover {
          .moreBoxImgs{
            .moreBoxImg2 {
              opacity: 0.7;
              transition: all 1s linear;
            }
            .moreBoxImg1 {
            }
          }
          .moreBoxContent {
            opacity: 0;
            transition: all .5s ease;
          }
      
          .list-font {
            opacity: 1 !important;
            transition: all .5s ease .5s;
          }
        }
        .moreBoxImgs{
          position: relative;
          .moreBoxImg2 {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            opacity: 0;
            transition: all 1.5s linear;
          }
          .moreBoxImg1{
            opacity: 0.8;
            transition: all 1s linear;
          }
        }
        .moreBoxContent {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          transition: all 1s ease .5s;
        }
        .list-font {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          width: 85%;
          opacity: 0;
          transition: all .5s ease;
          text-align: left;
        }
      }
      /*.list-hover {
        position: relative;
        &:hover{
          .bottom_list_title {
            opacity: 0 !important;
          }
          .bottom_list_font {
            position: absolute;
            top: 40%;
            left: 12%;
            opacity: 1;
            transition: opacity .3s linear .5s;
          }
        }
        .bottom_list_font {
          position: absolute;
            top: 40%;
            left: 12%;
          width: 70%;
          opacity: 0;
          transition: opacity .3s linear;
          }
        .bottom_list_one {
          display: block;
          position: relative;
          overflow: hidden;
          .bottom_list_title {
            text-align: center;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            overflow: hidden;
            opacity: 1;
            transition: opacity .2s linear .3s;
            h4 {
              font-family: "MiSans";
              color: rgb(255, 255, 255);
              margin: 20px 0;
            }
          }
        }
      }*/
    }
  }
}
</style>
<script>
import Layout from '../components/common/Layout'
import StaticBanner from "@/components/common/staticBanner/index.vue"
import SetupScroll from "@/components/common/setupScroll/index"
import seamlescroll from '@/components/common/seamlescroll/index.vue'
import "swiper/dist/css/swiper.css"
import { swiper, swiperSlide } from "vue-awesome-swiper"
export default {
  name: "ServiceSupport",
  components: { StaticBanner, SetupScroll,Layout,seamlescroll,swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 30,
        loop:true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
      },
      bannerDate: {
        url: require("@/assets/images/serviceSupport/08-1banner.png"),
        title: "服务与支持",
        content: "以客户成功为中心的核心价值观及咨询服务运营方法",
        btn: true,
      },
      bottonList: [
        {
          "img": require("../assets/images/industry/moreindustry1.png"),
          "imgIcon": require("../assets/images/serviceSupport/咨询服务icon.png"),
          "title": "咨询服务",
          "content":"企业数字化咨询、业财一体化数字化咨询、财务共享咨询、企业绩效咨询等"
        },
        {
          "img": require("../assets/images/industry/moreindustry2.png"),
          "imgIcon": require("../assets/images/serviceSupport/云产品订阅服务icon.png"),
          "title": "云产品订阅服务",
          "content":"包括ECOP平台（PaaS平台、低代码）、面向大型及超大型集团企业的EECloud产品、面向成长型企业的ESCloud产品"
        },
        {
          "img": require("../assets/images/industry/moreindustry3.png"),
          "imgIcon": require("../assets/images/serviceSupport/实施服务icon.png"),
          "title": "实施服务",
          "content":"专业的实施和配置工作"
        },
        {
          "img": require("../assets/images/industry/moreproduct3.png"),
          "imgIcon": require("../assets/images/serviceSupport/定制开发服务icon.png"),
          "title": "定制开发服务",
          "content":"1V1为您量身定制开发服务"
        },
      ],
      windowWidth: document.documentElement.clientWidth,
    }
  },
}
</script>


